<div class="max-h-[70vh] mt-2 overflow-y-auto mx-2 sm:mx-0">
  <ng-container *ngComponentOutlet="config.component;
                                    inputs: {
                                      queryChange: queryChange,
                                      requestSubmit: requestSubmit,
                                      submit: querySubmit
                                    }" #queryContainer></ng-container>
</div>
<button class="soft-button accent w-full h-16 mt-2" (click)="requestSubmit.emit()">Abfragen</button>
